import type { Member } from '@/core/data/members'

export function memberDisplayName(m: Pick<Member, 'vorname' | 'nachname' | 'email'>): string {
  const name = [m.vorname, m.nachname]
    .map((x) => (x ?? '').trim())
    .filter(Boolean)
    .join(' ')
  return name || m.email?.trim() || "Unbekannt"
}

export function isCoachOf(m: Pick<Member, 'userId'>, coachId: string | null, secondCoachId?: string | null): boolean {
  return m.userId === coachId || m.userId === secondCoachId
}

export function isLastOwner(members: readonly Pick<Member, 'userId' | 'isOwner'>[], userId: string): boolean {
  const owners = members.filter((m) => m.isOwner)
  return owners.length === 1 && owners[0].userId === userId
}

export function canRemoveMember(
  members: readonly Pick<Member, 'userId' | 'isOwner'>[],
  userId: string,
): boolean {
  return members.length > 1 && !isLastOwner(members, userId)
}
